module.exports = __webpack_public_path__ + "img/papirai-logo.977efd95.svg";